import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { WhatsNew } from './types';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, CardActionArea } from '@mui/material';
import { useDevice } from '../../../contexts/DeviceContext';
import { getCurrentLayout } from '../../../utils/ChooseLayout';
import { useResponsive } from '../../../contexts/ResponsiveContext';

function truncateText(text: string, maxLength: number): string {
    if (text.length <= maxLength) {
        return text;
    }
    return text.substring(0, maxLength) + '...';
}

export default function NewsCard(news: WhatsNew) {
    const { width } = useDevice();
    const layout = getCurrentLayout(width);
    const { isScreenLg, isScreenMd, isScreenSm, isScreenXs } = useResponsive();
    const maxTitleLengthLg = 88;
    const maxTitleLength = 110;

    // I changed this based on this ticket
    // https://www.wrike.com/open.htm?id=1621149151
    return (
        <Card
            variant="outlined"
            sx={{ ':hover': { opacity: 0.8 } }}
            style={{
                borderRadius: '0.63rem',
                height: layout === 'extra_small' ? '16.375rem' : '20.375rem',
                marginLeft: layout === 'extra_small' ? '0' : '0.5rem',
                marginRight: layout === 'extra_small' ? '0' : '0.35rem',
            }}
            data-testid={`${news.id}-area`}
        >
            <CardActionArea
                component={RouterLink}
                to={news.url}
                sx={{
                    overflow: 'hidden',
                    position: 'relative',
                    /* ↓↓↓ 只要滑進 CardActionArea（含文字區）就讓圖片放大 ↓↓↓ */
                    '& .MuiCardMedia-root': {
                        height: '100%',
                        width: '100%',
                        transition: 'transform 0.3s ease-in-out',
                        transformOrigin: 'center center',
                    },
                    '&:hover .MuiCardMedia-root': {
                        transform: 'scale(1.1)',
                    },
                }}
            >
                <Box
                    sx={{
                        overflow: 'hidden',
                        position: 'relative',
                        height: layout === 'extra_small' ? '9.375rem' : '13.375rem',
                    }}
                >
                    <CardMedia component="img" alt="" aria-hidden="true" image={news.image} />
                </Box>
                <CardContent
                    sx={{
                        borderTop: '0.5px solid #f2f2f2',
                        backgroundColor: '#191a1b',
                        color: 'white',
                        minHeight: '7rem',
                        alignContent: 'center',
                    }}
                >
                    <Typography
                        gutterBottom
                        fontSize={'1.25rem'}
                        fontWeight={'700'}
                        lineHeight="1.25rem"
                    >
                        {truncateText(
                            news.title,
                            isScreenLg || isScreenMd || isScreenXs || isScreenSm
                                ? maxTitleLengthLg
                                : maxTitleLength
                        )}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
